import { ComponentType } from 'react'

/** @public */
export type TLOnTheCanvas = ComponentType<object>
